export default __webpack_public_path__ + "static/media/table.14aadf19.svg";